
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9b3c1401fa149719$exports = {};

$parcel$export($9b3c1401fa149719$exports, "spectrum--medium", function () { return $9b3c1401fa149719$export$4c0c83b3f4303ef8; }, function (v) { return $9b3c1401fa149719$export$4c0c83b3f4303ef8 = v; });
var $9b3c1401fa149719$export$4c0c83b3f4303ef8;
$9b3c1401fa149719$export$4c0c83b3f4303ef8 = `rfm_fq_spectrum--medium`;


export {$9b3c1401fa149719$exports as default};
//# sourceMappingURL=vars_spectrum-medium_css.mjs.map
